import React, {useEffect, useState} from 'react';
import InputForm from "../../../../../components/input/input-form.jsx";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";
import {toast} from "react-toastify";
import Button from "../../../../../components/button/button.jsx";
import {FaCheck, FaPlus, FaTrash} from "react-icons/fa";
import projectUtils from "../../../../../utils/project-utils.js";

const PanelAreaDetails = ({setShowPanel, areaSelected, setAreas, areas, setItemsToRemove}) => {
    const [name, setName] = useState("")
    const [observation, setObservation] = useState("")
    const [color, setColor] = useState("")

    useEffect(() => {
        if (areaSelected?.data) {
            setName(areaSelected.data.name)
            setObservation(areaSelected.data.observation)
            setColor(areaSelected.data.color)
        }
    }, [areaSelected]);

    useEffect(() => {
        const areaFind = areas.find(a => a.id === areaSelected.id)
        if (areaFind) {
            areaFind.polygon.setOptions({strokeWeight: 2, fillColor: color, strokeColor: color});
        }
    }, [color]);

    const save = () => {
        if (!name) {
            projectUtils.swalErrorMessage('', "O campo \"Nome\" é obrigatório.", 'Ok');
            return
        }

        const data = {name, observation, color}
        setAreas(prevState => prevState.map(a => a.id === areaSelected.id ? { ...a, data } : a));

        setShowPanel(false)
        setName("")
        setObservation("")
    }

    const remove = () => {
        areaSelected.polygon.setMap(null);
        setShowPanel(false)
        setAreas(prevState => prevState.filter(a => a.id !== areaSelected.id));
        if (typeof areaSelected.id === "number") setItemsToRemove(prevState => ([...prevState, areaSelected.id]))
    }

    return (
        <>
            <div className={"h-[calc(100vh-120px)]"}>
                <div className={"mb-3"}>
                    <p className={"text-xs font-bold"}>Propriedades do setor</p>
                </div>
                <div className="grid grid-cols-12 gap-4 mb-3">
                    <div className="col-span-12">
                        <InputForm
                            id="name"
                            value={name}
                            label="Nome *"
                            onChange={({target: {value}}) => setName(value)}/>
                    </div>
                    <div className="col-span-12">
                        <label className="form-label">Cor</label>
                        <input type="color" className="block w-full" value={color} onChange={({target: {value}}) => setColor(value)}/>
                    </div>
                    <div className="col-span-12">
                        <InputTextarea
                            textAreaClass={"h-[80px]"}
                            label="Observações"
                            id={"observation"}
                            value={observation}
                            onChange={({target: {value}}) => setObservation(value)}/>
                    </div>
                </div>
            </div>

            <div className={"flex justify-end gap-3"}>
                <Button target={"danger"} onClick={remove}>
                    Remover
                </Button>
                <Button target={"primary-outline"} onClick={save}>
                    {
                        areaSelected?.data?.name
                            ? <><FaCheck /> Confirmar</>
                            : <><FaPlus /> Adicionar</>
                    }
                </Button>
            </div>
        </>
    );
};

export default PanelAreaDetails;